
import { GameState } from '../GameContextTypes';
import { Challenge } from '../../types/game';

export const setCurrentChallenge = (state: GameState, challenge: Challenge | null): GameState => {
  console.log('Setting current challenge:', challenge ? challenge.title : 'null');
  
  return {
    ...state,
    currentChallenge: challenge
  };
};
